import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import * as rest from '../../services'
import { reduxForm, Field } from 'redux-form'
import { FormButtons, validations, renderers, ICONS } from '../../components'
import { Slider } from '../../components'
import { reset } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import { VoucherPrint } from './prints'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { ESignaturePane } from '../ESignature'
import SlidingPane from 'react-sliding-pane'
const VOUCHER_FORM_NAME = 'voucher-form'
let VoucherForm = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12" md="6">
          <Field
            type="number"
            min="0.00"
            step="0.01"
            validate={[validations.required, validations.currency]}
            component={renderers.renderField}
            label="Cash Amount"
            name="cash"
            id="cash"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12" md="6">
          <Field
            validate={[validations.required, validations.currency]}
            component={renderers.renderField}
            label="Cheque Amount"
            type="number"
            min="0.00"
            step="0.01"
            name="cheque"
            id="cheque"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12" md="6">
          <Field
            validate={[validations.required, validations.currency]}
            component={renderers.renderField}
            type="number"
            min="0.00"
            step="0.01"
            label="Online Payment"
            name="online_payment"
            id="online_payment"
          />
        </ReactBootstrap.Col>





        <ReactBootstrap.Col xs="12" md="6">
          <Field
            validate={[validations.required, validations.currency]}
            component={renderers.renderField}
            type="number"
            min="0.00"
            step="0.01"
            label="Credit Card Amount"
            name="cc"
            id="cc"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12">
          <Field
            validate={[validations.required]}
            component={renderers.renderField}
            label="Online Payment Number"
            name="online_payment_reference_number"
            id="online_payment_reference_number"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12" md="6">
          <Field
            validate={[validations.required]}
            component={renderers.renderTextArea}
            label="Towards"
            name="towards"
            id="towards"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12" md="6">
          <Field
            component={renderers.renderTextArea}
            className="form-control"
            label="Note"
            name="note"
            id="note"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12" md="3">
          <Field
            component={renderers.renderField}
            label="Invoice Number"
            name="invoice_number"
            id="invoice_number"
          />
        </ReactBootstrap.Col>
            <ReactBootstrap.Col xs="12" md="3">
          <Field
            validate={[validations.required, validations.currency]}
            component={renderers.renderField}
            type="number"
            min="0.00"
            step="0.01"
            label="Refund Amount"
            name="refund_amount"
            id="refund_amount"
          />
        </ReactBootstrap.Col>
            <ReactBootstrap.Col className={"pt-2"} xs="12" md="3">
          <Field
            name="refund_date"
            label="Refund Date"
            component={renderers.renderDatePicker}

          />
        </ReactBootstrap.Col>
            <ReactBootstrap.Col xs="12" md="3">
          <Field
            component={renderers.renderField}
            label="UTRN Number "
            name="utrn_number"
            id="utrn_number"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12">
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
VoucherForm = reduxForm({
  form: VOUCHER_FORM_NAME,
})(VoucherForm)

const VOUCHER_CANCEL_FORM_NAME = 'voucher-cancel-form'
let VoucherCancelForm = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={renderers.renderTextArea}
        className="form-control"
        name="cancel_reason"
        rows="5"
        validate={[validations.required]}
      />
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
VoucherCancelForm = reduxForm({
  form: VOUCHER_CANCEL_FORM_NAME,
})(VoucherCancelForm)




const VOUCHER_INVOICE_FORM_NAME = 'voucher-invoice-form'
let VoucherInvoiceForm = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Field
         component={renderers.renderField}
        className="form-control"
        name="invoice_number"
        rows="5"
        validate={[validations.required]}
      />
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
VoucherInvoiceForm = reduxForm({
  form: VOUCHER_INVOICE_FORM_NAME,
})(VoucherInvoiceForm)



export const VoucherCancelButton = ({ voucher, onCancel, onError }) => {
  const dispatch = useDispatch()

     const [showReasonForm, setShowReasonForm] = useState(false);

  let OnDeleteReasonConfirm = function (values) {
    new rest.VoucherService(voucher.url)
      .cancel(values)
      .then((response) => {
        onCancel(response)
        dispatch(showSuccessToast('Success', 'Voucher Cancelled successfully'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      }).finally(()=>{
          setShowReasonForm(false)
    })
  }
  let OnDeleteConfirm = function () {
    setShowReasonForm(true)
  }
  return (
    <>
       <SlidingPane
           title={"Cancel Note"}
           overlayClassName="on-top"
        width={"50vw"}
        isOpen={showReasonForm}>
      <ReactBootstrap.Modal.Header closeButton>
        <ReactBootstrap.Modal.Title>Cancel Note</ReactBootstrap.Modal.Title>
      </ReactBootstrap.Modal.Header>

      <ReactBootstrap.Modal.Body>
        <VoucherCancelForm onSubmit={OnDeleteReasonConfirm} />
      </ReactBootstrap.Modal.Body>


    </SlidingPane>

      <components.Confirm
        onConfirm={OnDeleteConfirm}
        body="Are you sure you want to cancel this voucher?"
        confirmText="Confirm Cancel Voucher"
        confirmBSStyle="danger"
        title="Confirm Cancel Voucher"
      >


        <ReactBootstrap.Button

          size="sm"
          variant="danger"
          eventKey="1"
        >
          {components.ICONS.DELETE}
        </ReactBootstrap.Button>

      </components.Confirm>
    </>
  )
}


export const ChangeInvoiceButton = ({ voucher, onUpdate, onError }) => {
  const dispatch = useDispatch()

     const [showReasonForm, setShowReasonForm] = useState(false);

  let OnDeleteReasonConfirm = function (values) {
    new rest.VoucherService(voucher.url)
      .change_invoice_number(values.invoice_number)
      .then((response) => {
        setShowReasonForm(false)
        onUpdate(response)
        dispatch(showSuccessToast('Success', 'Voucher Invoice number changed successfully'))
      })
      .catch((errors) => {
        dispatch(showErrorToast('Error', errors.response.data))
      }).finally(()=>{
          setShowReasonForm(false)
    })
  }

  return (
    <>
       <SlidingPane
           title={"Update Invoice Number"}
           overlayClassName="on-top"
           onRequestClose={()=>setShowReasonForm(false)}
        width={"50vw"}
        isOpen={showReasonForm}>
      <ReactBootstrap.Modal.Header closeButton>
        <ReactBootstrap.Modal.Title>Update Invoice Number</ReactBootstrap.Modal.Title>
      </ReactBootstrap.Modal.Header>

      <ReactBootstrap.Modal.Body>
        <VoucherInvoiceForm onSubmit={OnDeleteReasonConfirm} />
      </ReactBootstrap.Modal.Body>


    </SlidingPane>



        <ReactBootstrap.Button

          size="sm"
          variant="danger"
          eventKey="1"
          style={{margin:"0 5px"}}
          onClick={()=>setShowReasonForm(true)}
        >
          {components.ICONS.EDIT} Invoice
        </ReactBootstrap.Button>

    </>
  )
}

const Voucher = ({ voucher, ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const VoucherEditForm = connect((state) => ({
    initialValues: voucher,
  }))(VoucherForm)
  const onUpdate = (values) => {
     if(values?.refund_date){
        values.refund_date =   values.refund_date?.toISOString?.().split('T')[0] ?? '';
    }
    new rest.VoucherService(voucher.url)
      .makePutRequest(values)
      .then((response) => {
        const updatedVouchers = ticket.vouchers.map((voucher) =>
                voucher.url === response.url ? response : voucher
           );
          onTicketUpdate({...ticket,vouchers:updatedVouchers})
        dispatch(
          showSuccessToast('Success', 'Voucher Information has been updated.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error on Voucher Information update',
            errors.response.data
          )
        )
      })
  }
  const onSendPdf = () => {
    new rest.VoucherService(voucher.url)
      .send_voucher_details_by_email_with_pdf().then((response) => {
        dispatch(
          showSuccessToast('Success', 'Voucher Information has been sent.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error on Voucher Information sending',
            errors.response.data
          )
        )
      })
  }

  return (
      <VoucherPrint ticket={ticket} voucher={voucher}>
      <div style={{display:"flex", gap:5, justifyContent:"flex-end"}}>
        <ESignaturePane
            id={voucher.id}
            guid={voucher.guid}
            url={voucher.url}
            type="voucher"
            code={voucher.reference_number}
            btnSize={"sm"}
        ></ESignaturePane>

          <span>
      <ChangeInvoiceButton voucher={voucher} onUpdate={(newVoucher) => {
          const updatedVouchers = ticket.vouchers.map((voucher) =>
              voucher.url === newVoucher.url ? newVoucher : voucher
          );
          onTicketUpdate({...ticket, vouchers: updatedVouchers})

      }}/>
          </span>
          <span>
      <VoucherCancelButton voucher={voucher} onCancel={(newVoucher) => {
          const updatedVouchers = ticket.vouchers.map((voucher) =>
              voucher.url === newVoucher.url ? newVoucher : voucher
          );
          onTicketUpdate({...ticket, vouchers: updatedVouchers})

      }}/>
          </span>
          <span>
         <ReactBootstrap.Button
             disabled={voucher.is_cancelled}
             size="sm"
             variant="success"
             eventKey="1"
             onClick={onSendPdf}
         >
          {components.ICONS.EMAIL}
         </ReactBootstrap.Button></span>

             <span>
                 <Slider
                 title={<>{ICONS.EDIT} Voucher</>}

                 header={
                     <>
                         {ICONS.EDIT} {voucher.reference_number}
                     </>
                 }
             >

        <VoucherEditForm onSubmit={onUpdate}/>
      </Slider>
             </span>
      </div>
      </VoucherPrint>
)
}

export const TicketVouchers = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()

  const createVoucher = (values) => {
    values.ticket = ticket.url
  if(values?.refund_date){
        values.refund_date =   values.refund_date?.toISOString?.().split('T')[0] ?? '';
    }

    new rest.VoucherService()
      .makePostRequest(values)
      .then((response) => {
        onTicketUpdate({...ticket,vouchers:[response,...ticket.vouchers]})
        dispatch(reset(VOUCHER_FORM_NAME))
        dispatch(showSuccessToast('Success', 'Voucher created successfully'))
      })
      .catch((errors) =>
        dispatch(showErrorToast('Error', errors.response.data))
      )
  }
  return (
    <>
      <div className="mt-5">
        <ReactBootstrap.Card className="mt-5">
          <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
            <ReactBootstrap.Row>
              <ReactBootstrap.Col xs="6">Vouchers</ReactBootstrap.Col>

              <ReactBootstrap.Col xs="6" className="text-end">
                <Slider header="Add Vouchers" title={components.ICONS.PLUS}>
                  <VoucherForm onSubmit={createVoucher} />
                </Slider>
              </ReactBootstrap.Col>
            </ReactBootstrap.Row>
          </ReactBootstrap.Card.Title>
          <ReactBootstrap.Card.Body>
            {ticket.vouchers.length ? (
              <components.ItemList
                itemRenderer={(index, key) => {
                  return (
                    <div className={"pt-4"} key={ticket.vouchers[index].url}>
                      <ReactBootstrap.ListGroupItem
                        variant={
                          ticket.vouchers[index].is_deleted ? 'danger' : ''
                        }
                      >
                        <Voucher
                          ticket={ticket}
                          voucher={ticket.vouchers[index]}
                          onTicketUpdate={onTicketUpdate}
                        />
                      </ReactBootstrap.ListGroupItem>
                    </div>
                  )
                }}
                length={ticket.vouchers.length}
              />
            ) : (
              <ReactBootstrap.Alert variant={'info'}>
                No previous vouchers found.
              </ReactBootstrap.Alert>
            )}
          </ReactBootstrap.Card.Body>
        </ReactBootstrap.Card>
      </div>
    </>
  )
}
